import { createSlice } from '@reduxjs/toolkit';
import {fetchData, setTs} from "./coreSlice";
import axios from '../axios-pogo';

const mapSlice = createSlice({
	name: 'map',
	initialState: {
		bounds: null, // [[42.5, -83.5], [43.5, -84.5]]
		zoom: null,
		nests: [],
		level14Centers: {}
	},
	reducers: {
		setBounds(state, action) { state.mapBounds = action.payload; },
		setZoom(state, action) {	state.zoom = action.payload;	},
		setNests(state, action) {	state.nests = action.payload;	},
		level14CenterAdded(state, action) { state.level14Centers[action.payload.key] = action.payload.obj; },
		level14CentersAdded(state, action) {
			action.payload.forEach(added => state.level14Centers[added.key] = added.obj);
		}
	}
});

export const { setBounds, setZoom, setTheme, setNests, level14CenterAdded, level14CentersAdded } = mapSlice.actions;

let lastBounds = null;
export const boundsChanged = (bounds) => {
	return (dispatch, getState) => {
		const boundsUnchanged = lastBounds && lastBounds[0][0] === bounds[0][0] && lastBounds[0][1] === bounds[0][1] &&
			lastBounds[0][1] === bounds[0][1] && lastBounds[1][1] === bounds[1][1];

		if( boundsUnchanged )
			return;

		const savedBounds = {lat: (bounds[0][0] + bounds[1][0]) / 2, lng: (bounds[0][1] + bounds[1][1]) / 2};
		localStorage.setItem('lastBounds', JSON.stringify(savedBounds));

		if( lastBounds && lastBounds[0][0] >= bounds[0][0] && lastBounds[0][1] >= bounds[0][1] &&
 			              lastBounds[0][1] >= bounds[0][1] && lastBounds[1][1] <= bounds[1][1]) {
			// console.log("Bounds unchanged or smaller, not refreshing.");
			if( !boundsUnchanged ) {
				lastBounds = bounds; // Don't put this in the if
				dispatch(setBounds(bounds));
			}

			return;
		}
		lastBounds = bounds; // Don't put this in the if




		dispatch(setTs(0));
		dispatch(setBounds(bounds));
		// dispatch(setBounds(bounds));

		// console.log("Bounds expanded, refreshing...");
		dispatch(fetchData(false));
	};
};

export const zoomChanged = (zoom) => {
	return (dispatch, getState) => {
		localStorage.setItem('lastZoom', zoom);

		dispatch(setTs(0));
		dispatch(setZoom(zoom));
		// TODO: react to stuff
	};
};

export const fetchNests = () => {
	return (dispatch, getState) => {
		axios.get('/mod/pokemon/map/ajax/get-nests.php').then(result => {
			dispatch(setNests(result.data));
		});
	};
};

export const centerMapOnGps = () => (dispatch, getState) => {
	if( !window.map || !window.maps )
		return;

	const state = getState();
	if( state.core.gpsLocation )
		console.log(state.core.gpsLocation);
	if( state.core.gpsLocation )
		window.map.panTo(new window.maps.LatLng(state.core.gpsLocation[0], state.core.gpsLocation[1]));
};

export default mapSlice.reducer;